<!--
 * @Author: your name
 * @Date: 2021-03-24 16:42:22
 * @LastEditTime: 2021-04-20 14:10:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/contract/index.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">商务合同列表</el-menu-item>
          <el-menu-item index="blogList">全部合作博主账号列表</el-menu-item>
          <el-menu-item index="invoice">全部开票记录</el-menu-item>
          <el-menu-item index="allAttachment">全部合同附件列表</el-menu-item>
          <el-menu-item index="create" v-if="permissions.contract_edit">创建商务合同</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <contract-list v-if="activeIndex == 'list'"></contract-list>
        <all-blogger-list v-else-if="activeIndex == 'blogList'" link-to="contract"></all-blogger-list>
        <lnvoice-list v-else-if="activeIndex == 'invoice'"></lnvoice-list>
        <contract-add v-else-if="activeIndex == 'create'" @toContractList="dealToContractList"></contract-add>
        <allAttachment v-else-if="activeIndex == 'allAttachment'" operateType="add"></allAttachment>
      </div>
    </div>
  </div>
</template>

<script>
import ContractList from "./component/list";
import AllBloggerList from "./media/list-all";
import LnvoiceList from "./invoice/invoice-all";
import ContractAdd from "./add";
import allAttachment from "./attachment/allattachment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
    };
  },
  components: {
    ContractList,
    AllBloggerList,
    LnvoiceList,
    ContractAdd,
    allAttachment
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>